<div
    class="agpr-monitoringResultsCharts"
    *ngIf="searchCriteria && searchCriteria.query"
>
    <agpr-panel
        styleClass="u-smBottomMargin"
        header="Monitoring.result.coverageSummary"
        [canOnlyClickIcon]="true"
    >
        <ng-template #panelHeader>
            <div class="agpr-panelHeader-actionButtons">
                <agpr-chart-export-menu
                    id="monitoringResultsCharts_coverageSummary_exportMenu"
                    [chartIdentifier]="classReference.COVERAGE_SUMMARY_CHART_ID"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'csv', 'json', 'print' ]"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [contextMenu]="false"
                    (exportMenuClicked)="handleExportClick($event)"
                ></agpr-chart-export-menu>
            </div>
        </ng-template>

        <div
            class="agpr-monitoringResultsCharts-coverageSummary"
            *ngIf="!contentNotFound"
        >
            <agpr-data-list-chart
                #coverageSummary
                [series]="coverageSummarySeries"
                [chartName]="coverageSummaryChartName"
                [chartOptions]="chartOptions"
            ></agpr-data-list-chart>
        </div>
        <agpr-message
            *ngIf="contentNotFound"
            [severity]="messageSeverityEnum.noContent"
            [bottomMargin]="false"
            [useWhiteBg]="true"
        >
            <span class="agpr-monitoringResultsCharts-noContentFound">
                {{ 'Monitoring.result.noContentFound' | localize }}
            </span>
        </agpr-message>
    </agpr-panel>
    <agpr-panel
        styleClass="u-smBottomMargin"
        header="Monitoring.result.coverageOverTime"
        [canOnlyClickIcon]="true"
    >
        <ng-template #panelHeader>
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-infoIconStyle"
                agprTooltip="Monitoring.chart.warning.tooltip"
            ></span>
            <div class="agpr-panelHeader-actionButtons">
                <agpr-chart-export-menu
                    id="monitoringResultsCharts_coverageOverTime_exportMenu"
                    [chartIdentifier]="classReference.COVERAGE_OVER_TIME_CHART_ID"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [contextMenu]="false"
                    (exportMenuClicked)="handleExportClick($event)"
                ></agpr-chart-export-menu>
            </div>
        </ng-template>

        <agpr-coverage-over-time
            *ngIf="!contentNotFound"
            #coverageOverTime
            (selectedDataItems)="coverageOverTimeClicked($event)"
            [data]="coverageOverTimeData"
        >
        </agpr-coverage-over-time>
        <agpr-message
            *ngIf="contentNotFound"
            [severity]="messageSeverityEnum.noContent"
            [bottomMargin]="false"
            [useWhiteBg]="true"
        >
            <span class="agpr-monitoringResultsCharts-noContentFound">
                {{ 'Monitoring.result.noContentFound' | localize }}
            </span>
        </agpr-message>
    </agpr-panel>
    <agpr-panel
        styleClass="u-smBottomMargin"
        header="Monitoring.result.sentimentBreakdown"
        [canOnlyClickIcon]="true"
    >
        <ng-template #panelHeader>
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-infoIconStyle"
                agprTooltip="Monitoring.sentiment.tooltip"
            ></span>
            <div class="agpr-panelHeader-actionButtons">
                <agpr-chart-export-menu
                    id="monitoringResultsCharts_sentimentBreakdown_exportMenu"
                    [chartIdentifier]="classReference.SENTIMENT_BREAKDOWN_CHART_ID"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [contextMenu]="false"
                    (exportMenuClicked)="handleExportClick($event)"
                ></agpr-chart-export-menu>
            </div>
        </ng-template>

        <div class="agpr-panel-custom-font-size">
            <agpr-donut-chart
                *ngIf="!contentNotFound"
                #sentimentBreakdown
                (selectedDataItems)="coverageOverTimeClicked($event)"
                [chartName]="classReference.SENTIMENT_BREAKDOWN_CHART_ID"
                [filterType]="classReference.FILTER_TYPE_SENTIMENT"
                [data]="sentimentBreakdownData"
            >
            </agpr-donut-chart>
        </div>
        <agpr-message
            *ngIf="contentNotFound"
            [severity]="messageSeverityEnum.noContent"
            [bottomMargin]="false"
            [useWhiteBg]="true"
        >
            <span class="agpr-monitoringResultsCharts-noContentFound">
                {{ 'Monitoring.result.noContentFound' | localize }}
            </span>
        </agpr-message>
    </agpr-panel>
    <agpr-panel
        *ngIf="currentRoute && currentRoute.type !== routeTypeEnum.subscriptionResults"
        styleClass="u-smBottomMargin"
        header="Monitoring.result.mediaTypeBreakdown"
        [canOnlyClickIcon]="true"
    >
        <ng-template #panelHeader>
            <div class="agpr-panelHeader-actionButtons">
                <agpr-chart-export-menu
                    id="monitoringResultsCharts_meadiTypeBreakdown_exportMenu"
                    [chartIdentifier]="classReference.MEDIA_TYPE_BREAKDOWN_CHART_ID"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [contextMenu]="false"
                    (exportMenuClicked)="handleExportClick($event)"
                ></agpr-chart-export-menu>
            </div>
        </ng-template>

        <div class="agpr-panel-custom-font-size">
            <agpr-donut-chart
                *ngIf="!contentNotFound"
                #mediaTypeBreakdown
                (selectedDataItems)="coverageOverTimeClicked($event)"
                [chartName]="classReference.MEDIA_TYPE_BREAKDOWN_CHART_ID"
                [filterType]="classReference.FILTER_TYPE_MEDIA_TYPE"
                [data]="mediaTypeBreakdownData"
            >
            </agpr-donut-chart>
        </div>
        <agpr-message
            *ngIf="contentNotFound"
            [severity]="messageSeverityEnum.noContent"
            [bottomMargin]="false"
            [useWhiteBg]="true"
        >
            <span class="agpr-monitoringResultsCharts-noContentFound">
                {{ 'Monitoring.result.noContentFound' | localize }}
            </span>
        </agpr-message>
    </agpr-panel>
</div>
